import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import returnManagementService from "services/returnManagementService";

const initialState = {
  loading: false,
  updateLoading: false,
  returns: [],
  availableStatuses: [],
  availableActions: [],
  total: 0,
  message: "",
  showMessage: false,
};

export const getReturns = createAsyncThunk(
  "returnManagement/getReturns",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await returnManagementService.getReturns(params);
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error fetching returns");
    }
  }
);

export const updateReturn = createAsyncThunk(
  "returnManagement/updateReturn",
  async (data = {}, { rejectWithValue }) => {
    try {
      const response = await returnManagementService.updateReturn(data);
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error updating return");
    }
  }
);

const returnManagementSlice = createSlice({
  name: "returnManagement",
  initialState,
  reducers: {
    clearReturnMessage: (state) => {
      state.message = "";
      state.showMessage = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReturns.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReturns.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.returns = payload.data || [];
        state.total = payload.total || 0;
        state.availableStatuses = payload.available_statuses || [];
        state.availableActions = payload.available_actions || [];
      })
      .addCase(getReturns.rejected, (state, { payload }) => {
        state.loading = false;
        state.message = payload;
        state.showMessage = true;
      })
      .addCase(updateReturn.pending, (state) => {
        state.updateLoading = true;
      })
      .addCase(updateReturn.fulfilled, (state) => {
        state.updateLoading = false;
      })
      .addCase(updateReturn.rejected, (state, { payload }) => {
        state.updateLoading = false;
        state.message = payload;
        state.showMessage = true;
      });
  },
});

export const { clearReturnMessage } = returnManagementSlice.actions;
export default returnManagementSlice.reducer;
